var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navbar"},[_c('breadcrumb'),_c('div',{staticClass:"navbar-right"},[_c('avatar')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }